export const ActiveUserStatus = 0;
export const COUNTDOWN_TIME = 30;
export const OTP_LENGTH = 6;
